import type { ComponentProps } from "react"
import { DialogClose as DialogCloseBase } from "@/v2-ui/dialog/base/DialogBase"

export type DialogCloseProps = ComponentProps<typeof DialogCloseBase>

function DialogClose(props: DialogCloseProps) {
  const { ...dialogCloseBaseProps } = props
  return <DialogCloseBase {...dialogCloseBaseProps} />
}

export default DialogClose
